import type { BoxProps, PaperProps } from '@mui/material';
import CoverageDetails from './CoverageDetails';
import type { UseMergePresetsAndCoveragesParams } from '../../hooks/useMergePresetsAndCoverages';
import useMergePresetsAndCoverages from '../../hooks/useMergePresetsAndCoverages';

interface ICoverageDetailsDataProcessor
  extends UseMergePresetsAndCoveragesParams {
  boxProps?: BoxProps;
  containerProps?: PaperProps;
}

const CoverageDetailsDataProcessor = (props: ICoverageDetailsDataProcessor) => {
  const {
    coverages,
    effectiveDate,
    productType,
    limit: aggLimit,
    deductible,
    agencyId,
    accountData,
    ...restProps
  } = props;

  const mergePresetsAndCoverages = useMergePresetsAndCoverages({
    coverages,
    effectiveDate,
    productType,
    limit: aggLimit,
    deductible,
    agencyId,
    accountData,
  });

  return (
    <CoverageDetails
      coveragesByGrouping={mergePresetsAndCoverages?.coveragesByGrouping}
      productType={productType}
      {...restProps}
    />
  );
};

export default CoverageDetailsDataProcessor;
